'use strict';

const EDIT_LOCATION_PERMISSION = "EditLocation";

angular.module('clientDashboardApp').directive('listingEditor', function ($uibModal, userService) {

  return {
    restrict: 'A',
    scope: {
      locationId: '=',
      provider: '='
    },
    template: '<a ng-if="hasEditLocationPermission" class="edit-link pull-right font-weight-bold cursor-pointer" ng-click="openModal()">Edit/Add URL</a>',
    link: function (scope, elem, attrs, ctrl) {
      userService.currentUser().then(user => {
        scope.hasEditLocationPermission = user.permissions.includes(EDIT_LOCATION_PERMISSION);
      });

      scope.openModal = function () {
        $uibModal.open({
          template: require('../listingEditor.html'),
          controller: 'ListingEditorCtrl',
          size: 'lg',
          resolve: {
            listingOptions: function () {
              return {
                locationId: scope.locationId,
                provider: scope.provider
              };
            },
          }
        });

      };
    }
  }
});
